module.exports = __webpack_public_path__ + "images/emoji/light_rail.d22c48729d035a754041.png";